import { render, staticRenderFns } from "./purchase_order_detail.vue?vue&type=template&id=8c2d4eec&scoped=true"
import script from "./purchase_order_detail.vue?vue&type=script&lang=js"
export * from "./purchase_order_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2d4eec",
  null
  
)

export default component.exports